import dayjs from 'dayjs'
import type { Href } from 'expo-router'
import { useEffect } from 'react'

import { routeToPath } from '@/src/general/constants/routes'
import { ONE_DAY_IN_MS } from '@/src/general/constants/time'
import { storage } from '@/src/general/utilities/storage'
import { STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'
import { useRoutes } from '@/src/general/utils/routes'

import { useIsRosarioUserQuery } from './useIsRosarioUserQuery'

const getXMRPMCTAHistory = (): { amount?: number; lastRequestDateMs?: number } => {
  try {
    const xmrpmCtaHistory = JSON.parse(storage.getItem(STORAGE_KEYS.XMRPM_CTA) || '{}')
    return typeof xmrpmCtaHistory === 'object' ? xmrpmCtaHistory : {}
  } catch (_error) {
    return {}
  }
}

export const useXMRPMRedirect = ({ destination }: { destination: Href }) => {
  const { routes } = useRoutes()
  const { data } = useIsRosarioUserQuery()

  if (data?.isRosarioUser) return destination

  const now = Date.now()
  const isDisplayPeriod = dayjs(now).isAfter('2026-05-01') && dayjs(now).isBefore('2026-05-29')

  if (!isDisplayPeriod) return destination

  const { amount = 0, lastRequestDateMs = 0 } = getXMRPMCTAHistory()

  const hasReachedMaximumDisplayCount = amount >= 3
  const hasWaitedEnoughAfterLastDisplay = !lastRequestDateMs || now - lastRequestDateMs >= 3 * ONE_DAY_IN_MS

  if (
    hasReachedMaximumDisplayCount ||
    !hasWaitedEnoughAfterLastDisplay ||
    (window && window.location && window.location.host?.includes('local'))
  )
    return destination

  return routes.rosarioRoses({ redirect: routeToPath(destination) })
}

export const useUpdateXMRPMCTAHistory = () =>
  useEffect(() => {
    const { amount = 0 } = getXMRPMCTAHistory()
    storage.setItem(STORAGE_KEYS.XMRPM_CTA, JSON.stringify({ amount: amount + 1, lastRequestDateMs: Date.now() }))
  }, [])
